import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentCategory',
  standalone: true
})
export class PaymentCategoryPipe implements PipeTransform {

  transform(type: string): string {
    switch (type) {
      case 'CARD':
        return 'Credit/Debit';
      case 'ACH':
        return 'ACH';
      case 'CHECK':
        return 'Check';
      case 'CASH':
        return 'Cash';
      case 'PAYPAL':
        return 'PayPal';
      case 'VENMO':
        return 'Venmo';
      case 'CASH APP':
        return 'Cash App';
      case 'ZELLE':
        return 'Zelle';
      case 'SHORT_PAYMENT':
        return 'Short Payment'
      case 'OTHER':
        return 'Other';
      case 'CREDIT NOTE':
        return 'Credit Note';
      default:
        return 'Unknown';
    }
  }
}
